import { usePaywallStore } from './usePaywallStore'

// Opens the upgrade dialog instead of the build step when a new graph would
// exceed the free cap. The server enforces the same; this spares the wait.
export async function refuseNewGraphAtCap(contextName, ownedContextNames) {
    if (!contextName || ownedContextNames.includes(contextName)) return false
    const usage = await usePaywallStore.getState().loadUsage(true)
    const graphs = usage && usage.graphsCreated
    if (!graphs || graphs.limit == null || graphs.used < graphs.limit)
        return false
    usePaywallStore.getState().openUpgradeDialog({
        code: 'QUOTA_GRAPHS',
        limit: graphs.limit,
        used: graphs.used,
    })
    return true
}
